import { getEntities } from "../../entities/selectors";
import { PARTIES_ENTITIES } from "./consts";

/**
 * Get parties saved in entities
 */
export const getPartiesEntities = (state) => getEntities(state, PARTIES_ENTITIES);
